import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import { PageRequest, WorkflowEvent } from '@models/models';
import { DashboardDataServiceProvider } from '@services/dashboard/dashboard.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'shoots-appointments-block',
	template: require('./shoots-appointments-block.html'),
	styles: [require('./shoots-appointments-block.scss')]
})
export class ShootsAppointmentsBlockComponent implements OnInit {
	@Input() buttonDisabled: boolean;
	@Input() spinningWheelActive: boolean;
	@Output()
	chooseModalTrigger: EventEmitter<WorkflowEvent> = new EventEmitter<
		WorkflowEvent
	>();
	unsubscribe: Subject<void> = new Subject();

	data: WorkflowEvent[] = [];
	flatData: WorkflowEvent[] = [];
	itemsQuantity: number;
	pagesQuantity: number;
	pageRequest: PageRequest;

	readonly PAGE_REQUEST_DEFAULT: PageRequest = {
		filterBy: 'upcoming',
		paging: {
			pageNumber: 0,
			pageSize: 12,
			searchToken: null
		},
		sortCriterias: [
			{
				fieldName: 'startDate',
				sortAscending: true
			},

			{
				fieldName: 'startTime',
				sortAscending: true
			}
		]
	};

	constructor(
		private http: HttpClient,
		private dashboardDataService: DashboardDataServiceProvider,
		private messageService: MessageService
	) {}

	ngOnInit() {
		this.pageRequest = this.PAGE_REQUEST_DEFAULT;
		this.configureCommunicationAdapter();
		this.getData();
	}

	addNew(): void {
		$('#addNewModal').modal('show');
	}

	showEvent(event, $event): void {
		if ($event && $event.stopPropagation) {
			$event.stopPropagation();
		}

		if (
			event &&
			(this.isJob(event) || (this.isAppointment(event) && event.jobId))
		) {
			return;
		}

		this.chooseModalTrigger.emit(event);
	}

	private getData(): void {
		this.dashboardDataService
			.getShootsAppointmentsData(this.pageRequest)
			.subscribe(
				data => this.successGetData(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	updateData(pageRequest: PageRequest) {
		this.pageRequest = pageRequest;
		this.dashboardDataService
			.getShootsAppointmentsData(pageRequest)
			.subscribe(
				data => this.successGetData(data),
				error => this.messageService.showDefaultErrorMessage(error)
			);
	}

	paginationToDefaults() {
		this.pageRequest = this.PAGE_REQUEST_DEFAULT;
		delete this.pageRequest.paging.searchToken;
		this.getData();
	}

	private successGetData(data) {
		this.pageRequest.paging.searchToken = data.searchToken;
		this.itemsQuantity = data.totalSize;
		this.pagesQuantity = Math.ceil(
			this.itemsQuantity / this.pageRequest.paging.pageSize
		);
		this.flatData = data.items;
		this.data = this.reformatData(data);
	}

	private reformatData(data) {
		const groups = data.items.reduce((groups, item) => {
			(groups[item.startDate] = groups[item.startDate] || []).push(item);
			return groups;
		}, {});

		const result = Object.keys(groups).map(k => groups[k]);
		return result;
	}

	private isJob(event) {
		return event.calendarEventType === 'MAIN_SHOOT';
	}

	private isAppointment(event) {
		return event.calendarEventType === 'APPOINTMENT';
	}

	private updateModel(resetPagination: boolean): void {
		if (resetPagination) {
			this.paginationToDefaults();
		} else {
			this.getData();
		}
	}

	private configureCommunicationAdapter(): void {
		window.snCommunicationAdapter.registerMethod(
			'updateShootsModel',
			this.updateModel.bind(this)
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/dashboard/shoots-appointments-block/shoots-appointments-block.ts